/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShadowSubsystemAuditStep
 */
export interface ShadowSubsystemAuditStep {
    /**
     * 
     */
    step: string;
    /**
     * 
     */
    detail: string;
    /**
     * 
     */
    outcome: string;
}

/**
 * Check if a given object implements the ShadowSubsystemAuditStep interface.
 */
export function instanceOfShadowSubsystemAuditStep(value: object): value is ShadowSubsystemAuditStep {
    if (!('step' in value) || value['step'] === undefined) return false;
    if (!('detail' in value) || value['detail'] === undefined) return false;
    if (!('outcome' in value) || value['outcome'] === undefined) return false;
    return true;
}

export function ShadowSubsystemAuditStepFromJSON(json: any): ShadowSubsystemAuditStep {
    return ShadowSubsystemAuditStepFromJSONTyped(json, false);
}

export function ShadowSubsystemAuditStepFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowSubsystemAuditStep {
    if (json == null) {
        return json;
    }
    return {
        
        'step': json['step'],
        'detail': json['detail'],
        'outcome': json['outcome'],
    };
}

export function ShadowSubsystemAuditStepToJSON(json: any): ShadowSubsystemAuditStep {
    return ShadowSubsystemAuditStepToJSONTyped(json, false);
}

export function ShadowSubsystemAuditStepToJSONTyped(value?: ShadowSubsystemAuditStep | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'step': value['step'],
        'detail': value['detail'],
        'outcome': value['outcome'],
    };
}

